export default __webpack_public_path__ + "de761ad0a6eed3c2deaa120d73bca6eb.png";